<img [src]="img" alt="">